<div class="main-container">
  <div class="d-flex flex-column align-items-center flex-column">
    <button psUiButton class="top-btn my-2" (click)="editCountryQuota()">
      Edit Locale Quota
    </button>
  </div>
  <ps-ui-table [data]="multiCountrySpvChildSurveys">
    <ng-container
      psUiTableExpandableRow
      [behavior]="'each'"
      [manualClose]="true"
    >
      <ng-container
        psUiTableCheckboxColumn
        selectBy="survey_id"
        [show]="false"
        [showSelectAll]="false"
        [selectedKeys]="[currentlySelectedSpvSurvey?.ps_survey_id]"
      ></ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header-container">Locale</div>
        </ng-template>
        <ng-template
          psUiTableCellTemplate
          (tap)="onSurveySelection($event)"
          let-survey
        >
          <div class="content-container justify-content-start">
            {{ survey.country_name }}
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header-container"></div>
        </ng-template>
        <ng-template
          psUiTableCellTemplate
          (tap)="onSurveySelection($event)"
          let-survey
        >
          <div class="content-container">
            <span class="p-1 fw-bold language-icon">{{
              survey.language_code | uppercase
            }}</span>
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header-container">CPI</div>
        </ng-template>
        <ng-template let-survey let-row="index" psUiTableCellTemplate>
          <div class="content-container">
            <div class="d-flex align-items-center" *ngIf="!survey.loading">
              <div class="d-flex align-items-center flex-column">
                <ng-container *ngIf="isCpiEditable">
                  <div
                    title="click to edit"
                    class="d-flex align-items-center"
                    *ngIf="survey.state.cpi === 'view'"
                  >
                    {{ survey.currency_symbol
                    }}{{ survey.cpi | number : '1.2-2' }}
                    <span
                      (click)="survey.state.cpi = 'edit'"
                      class="mx-1 fa fa-pencil"
                    ></span>
                  </div>

                  <ng-container *ngIf="survey.state.cpi !== 'view'">
                    {{ survey.currency_symbol }}
                    <input
                      (ngModelChange)="onCpiValueChange($event, survey, row)"
                      [ngModel]="survey.cpi"
                      psUiInputDecimalRestriction
                      psUiInputRestriction="[0-9.]"
                      [value]="survey.cpi | number : '1.2-2'"
                      class="cpi-input-box p-1 mx-1"
                      type="number"
                      #inputCpi
                    />
                    <div
                      class="action-container d-flex justify-content-center align-items-center"
                    >
                      <div
                        (click)="onCpiValueUpdate(inputCpi.value, survey)"
                        class="p-1 fa fa-check d-flex align-items-center glyphicon glyphicon-ok"
                      ></div>
                      <div
                        (click)="
                          survey.state.cpi = 'view'; hideCpiConfirmationRow(row)
                        "
                        class="p-1 text-danger fa fa-remove d-flex align-items-center glyphicon glyphicon-remove"
                      ></div>
                    </div>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="!isCpiEditable">
                  {{ survey.currency_symbol
                  }}{{ survey.cpi | number : '1.2-2' }}
                </ng-container>
              </div>
            </div>
            <ps-ui-ellipsis-loader
              [show]="survey?.loading"
            ></ps-ui-ellipsis-loader>
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header-container">Completes</div>
        </ng-template>
        <ng-template psUiTableCellTemplate let-survey>
          <div class="content-container">
            <div class="d-flex align-items-center flex-column">
              <div
                *ngIf="survey.state.completes_required === 'view'"
                class="d-flex align-items-center"
                title="click to edit"
              >
                {{ survey.completes_required }}
                <span
                  class="fa fa-pencil mx-1"
                  (click)="survey.state.completes_required = 'edit'"
                ></span>
              </div>

              <ng-container *ngIf="survey.state.completes_required === 'edit'">
                <input
                  [ngModel]="survey.completes_required"
                  psUiInputDecimalRestriction
                  psUiInputRestriction="[0-9]"
                  [value]="survey.completes_required"
                  class="cpi-input-box p-1 mx-1"
                  oninput="if(this.value.length>5){ this.value = this.value.slice(0,5) }"
                  type="number"
                  #inputCompletes
                />
                <div
                  class="action-container d-flex justify-content-center align-items-center"
                >
                  <div
                    (click)="onCompletesUpdate(inputCompletes.value, survey)"
                    class="p-1 fa fa-check d-flex align-items-center glyphicon glyphicon-ok"
                  ></div>
                  <div
                    (click)="survey.state.completes_required = 'view'"
                    class="p-1 text-danger fa fa-remove d-flex align-items-center glyphicon glyphicon-remove"
                  ></div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header-container">Feasibility</div>
        </ng-template>
        <ng-template
          psUiTableCellTemplate
          (tap)="onSurveySelection($event)"
          let-survey
        >
          <div class="content-container">
            <div class="d-flex align-items-center flex-column">
              <span *ngIf="!survey.loading">
                {{ survey.feasibility | number }}
              </span>
              <ps-ui-ellipsis-loader
                [show]="survey.loading"
              ></ps-ui-ellipsis-loader>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="!isNotDraftSurvey" psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header-container">Delete</div>
        </ng-template>
        <ng-template
          psUiTableCellTemplate
          let-survey
          (tap)="onChildSurveyDelete($event)"
        >
          <div class="content-container">
            <div class="d-flex align-items-center flex-column">
              <i class="fa fa-trash"></i>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <ng-template psUiTableExpandableContent let-survey let-index="index">
        <div class="d-flex align-items-center confirm-box">
          <div class="p-1">
            Please confirm the Override CPI value you have entered to the
            accurate
          </div>
          <div class="multicountry-confirm-button">
            <button
              type="button"
              psUiButton
              size="small"
              (click)="onCpiConfirmation(survey, index)"
            >
              Confirm
            </button>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </ps-ui-table>

  <ng-container *ngIf="multiCountrySpvChildSurveys.length && !isNotDraftSurvey">
    <div class="d-flex py-2 justify-content-around flex-row">
      <div>
        <ps-ui-select-dropdown
          class="btn country-dropdown"
          [dropdownItems]="filteredCountries"
          [field]="'name'"
          [loading]="false"
          [clearSearch]="false"
          [label]="selectedCountry.name || 'Select Country'"
          labelNone="Select Country"
          labelAlignment="start"
          (selectedItem)="selectCountry($event)"
        >
        </ps-ui-select-dropdown>
      </div>

      <div>
        <ps-ui-select-dropdown
          class="btn country-dropdown"
          [dropdownItems]="selectedCountry.lang || []"
          [field]="'name'"
          [loading]="false"
          [clearSearch]="false"
          [disabled]="!selectedCountry.lang?.length"
          [firstSelected]="true"
          labelNone="Select Language"
          labelAlignment="start"
          (selectedItem)="setLanguage($event)"
        >
        </ps-ui-select-dropdown>
      </div>

      <div
        class="d-flex align-items-center fa fa-check glyphicon glyphicon-ok p-1 mx-1 text-white bg-primary new-survey-button"
        (click)="onNewSurveyCreation()"
      ></div>
    </div>
  </ng-container>
</div>
